export const LocationList = [
  { label: 'Afghanistan - AF', value: 'AF', text: '' },
  { label: 'Aland Islands - AX', value: 'AX', text: '' },
  { label: 'Albania - AL', value: 'AL', text: '' },
  { label: 'Algeria - DZ', value: 'DZ', text: '' },
  { label: 'American Samoa - AS', value: 'AS', text: '' },
  { label: 'Andorra - AD', value: 'AD', text: '' },
  { label: 'Angola - AO', value: 'AO', text: '' },
  { label: 'Anguilla - AI', value: 'AI', text: '' },
  { label: 'Antarctica - AQ', value: 'AQ', text: '' },
  { label: 'Antigua and Barbuda - AG', value: 'AG', text: '' },
  { label: 'Argentina - AR', value: 'AR', text: '' },
  { label: 'Armenia - AM', value: 'AM', text: '' },
  { label: 'Aruba - AW', value: 'AW', text: '' },
  { label: 'Australia - AU', value: 'AU', text: '' },
  { label: 'Austria - AT', value: 'AT', text: '' },
  { label: 'Azerbaijan - AZ', value: 'AZ', text: '' },
  { label: 'Bahamas - BS', value: 'BS', text: '' },
  { label: 'Bahrain - BH', value: 'BH', text: '' },
  { label: 'Bangladesh - BD', value: 'BD', text: '' },
  { label: 'Barbados - BB', value: 'BB', text: '' },
  { label: 'Belarus - BY', value: 'BY', text: '' },
  { label: 'Belgium - BE', value: 'BE', text: '' },
  { label: 'Belize - BZ', value: 'BZ', text: '' },
  { label: 'Benin - BJ', value: 'BJ', text: '' },
  { label: 'Bermuda - BM', value: 'BM', text: '' },
  { label: 'Bhutan - BT', value: 'BT', text: '' },
  { label: 'Bolivia, Plurinational State of - BO', value: 'BO', text: '' },
  { label: 'Bonaire, Sint Eustatius and Saba - BQ', value: 'BQ', text: '' },
  { label: 'Bosnia and Herzegovina - BA', value: 'BA', text: '' },
  { label: 'Botswana - BW', value: 'BW', text: '' },
  { label: 'Bouvet Island - BV', value: 'BV', text: '' },
  { label: 'Brazil - BR', value: 'BR', text: '' },
  { label: 'British Indian Ocean Territory - IO', value: 'IO', text: '' },
  { label: 'Brunei Darussalam - BN', value: 'BN', text: '' },
  { label: 'Bulgaria - BG', value: 'BG', text: '' },
  { label: 'Burkina Faso - BF', value: 'BF', text: '' },
  { label: 'Burundi - BI', value: 'BI', text: '' },
  { label: 'Cambodia - KH', value: 'KH', text: '' },
  { label: 'Cameroon - CM', value: 'CM', text: '' },
  { label: 'Canada - CA', value: 'CA', text: '' },
  { label: 'Cape Verde - CV', value: 'CV', text: '' },
  { label: 'Cayman Islands - KY', value: 'KY', text: '' },
  { label: 'Central African Republic - CF', value: 'CF', text: '' },
  { label: 'Chad - TD', value: 'TD', text: '' },
  { label: 'Chile - CL', value: 'CL', text: '' },
  { label: 'China - CN', value: 'CN', text: '' },
  { label: 'Christmas Island - CX', value: 'CX', text: '' },
  { label: 'Cocos (Keeling) Islands - CC', value: 'CC', text: '' },
  { label: 'Colombia - CO', value: 'CO', text: '' },
  { label: 'Comoros - KM', value: 'KM', text: '' },
  { label: 'Congo - CG', value: 'CG', text: '' },
  { label: 'Congo, the Democratic Republic of the - CD', value: 'CD', text: '' },
  { label: 'Cook Islands - CK', value: 'CK', text: '' },
  { label: 'Costa Rica - CR', value: 'CR', text: '' },
  { label: 'Cote D\'Ivoire - CI', value: 'CI', text: '' },
  { label: 'Croatia - HR', value: 'HR', text: '' },
  { label: 'Cuba - CU', value: 'CU', text: '' },
  { label: 'Curacao - CW', value: 'CW', text: '' },
  { label: 'Cyprus - CY', value: 'CY', text: '' },
  { label: 'Czech Republic - CZ', value: 'CZ', text: '' },
  { label: 'Denmark - DK', value: 'DK', text: '' },
  { label: 'Djibouti - DJ', value: 'DJ', text: '' },
  { label: 'Dominica - DM', value: 'DM', text: '' },
  { label: 'Dominican Republic - DO', value: 'DO', text: '' },
  { label: 'Ecuador - EC', value: 'EC', text: '' },
  { label: 'Egypt - EG', value: 'EG', text: '' },
  { label: 'El Salvador - SV', value: 'SV', text: '' },
  { label: 'Equatorial Guinea - GQ', value: 'GQ', text: '' },
  { label: 'Eritrea - ER', value: 'ER', text: '' },
  { label: 'Estonia - EE', value: 'EE', text: '' },
  { label: 'Ethiopia - ET', value: 'EF', text: '' },
  { label: 'Falkland Islands (Malvinas) - FK', value: 'FK', text: '' },
  { label: 'Faroe Islands - FO', value: 'FO', text: '' },
  { label: 'Fiji - FJ', value: 'FJ', text: '' },
  { label: 'Finland - FI', value: 'FI', text: '' },
  { label: 'France - FR', value: 'FR', text: '' },
  { label: 'French Guiana - GF', value: 'GF', text: '' },
  { label: 'French Polynesia - PF', value: 'PF', text: '' },
  { label: 'French Southern Territories - TF', value: 'TF', text: '' },
  { label: 'Gabon - GA', value: 'GA', text: '' },
  { label: 'Gambia - GM', value: 'GM', text: '' },
  { label: 'Georgia - GE', value: 'GE', text: '' },
  { label: 'Germany - DE', value: 'DE', text: '' },
  { label: 'Ghana - GH', value: 'GH', text: '' },
  { label: 'Gibraltar - GI', value: 'GI', text: '' },
  { label: 'Greece - GR', value: 'GR', text: '' },
  { label: 'Greenland - GL', value: 'GL', text: '' },
  { label: 'Grenada - GD', value: 'GD', text: '' },
  { label: 'Guadeloupe - GP', value: 'GP', text: '' },
  { label: 'Guam - GU', value: 'GU', text: '' },
  { label: 'Guatemala - GT', value: 'GT', text: '' },
  { label: 'Guernsey - GG', value: 'GG', text: '' },
  { label: 'Guinea - GN', value: 'GN', text: '' },
  { label: 'Guinea-Bissau - GW', value: 'GW', text: '' },
  { label: 'Guyana - GY', value: 'GY', text: '' },
  { label: 'Haiti - HT', value: 'HT', text: '' },
  { label: 'Heard Island and McDonald Islands - HM', value: 'HM', text: '' },
  { label: 'Holy See (Vatican City State) - VA', value: 'VA', text: '' },
  { label: 'Honduras - HN', value: 'HN', text: '' },
  { label: 'Hong Kong - HK', value: 'HK', text: '' },
  { label: 'Hungary - HU', value: 'HU', text: '' },
  { label: 'Iceland - IS', value: 'IS', text: '' },
  { label: 'India - IN', value: 'IN', text: '' },
  { label: 'Indonesia - ID', value: 'ID', text: '' },
  { label: 'Iran, Islamic Republic of - IR', value: 'IR', text: '' },
  { label: 'Iraq - IQ', value: 'IQ', text: '' },
  { label: 'Ireland - IE', value: 'IE', text: '' },
  { label: 'Isle of Man - IM', value: 'IM', text: '' },
  { label: 'Israel - IL', value: 'IL', text: '' },
  { label: 'Italy - IT', value: 'IT', text: '' },
  { label: 'Jamaica - JM', value: 'JM', text: '' },
  { label: 'Japan - JP', value: 'JP', text: '' },
  { label: 'Jersey - JE', value: 'JE', text: '' },
  { label: 'Jordan - JO', value: 'JO', text: '' },
  { label: 'Kazakhstan - KZ', value: 'KZ', text: '' },
  { label: 'Kenya - KE', value: 'KE', text: '' },
  { label: 'Kiribati - KI', value: 'KI', text: '' },
  { label: 'Korea, Democratic People\'s Republic of - KP', value: 'KP', text: '' },
  { label: 'Korea, Republic of - KR', value: 'KR', text: '' },
  { label: 'Kuwait - KW', value: 'KW', text: '' },
  { label: 'Kyrgyzstan - KG', value: 'KG', text: '' },
  { label: 'Lao People\'s Democratic Republic - LA', value: 'LA', text: '' },
  { label: 'Latvia - LV', value: 'LV', text: '' },
  { label: 'Lebanon - LB', value: 'LB', text: '' },
  { label: 'Lesotho - LS', value: 'LS', text: '' },
  { label: 'Liberia - LR', value: 'LR', text: '' },
  { label: 'Libya - LY', value: 'LY', text: '' },
  { label: 'Liechtenstein - LI', value: 'LI', text: '' },
  { label: 'Lithuania - LT', value: 'LT', text: '' },
  { label: 'Luxembourg - LU', value: 'LU', text: '' },
  { label: 'Macao - MO', value: 'MO', text: '' },
  { label: 'Macedonia, the Former Yugoslav Republic of - MK', value: 'MK', text: '' },
  { label: 'Madagascar - MG', value: 'MG', text: '' },
  { label: 'Malawi - MW', value: 'MW', text: '' },
  { label: 'Malaysia - MY', value: 'MY', text: '' },
  { label: 'Maldives - MV', value: 'MV', text: '' },
  { label: 'Mali - ML', value: 'ML', text: '' },
  { label: 'Malta - MT', value: 'MT', text: '' },
  { label: 'Marshall Islands - MH', value: 'MH', text: '' },
  { label: 'Martinique - MQ', value: 'MQ', text: '' },
  { label: 'Mauritania - MR', value: 'MR', text: '' },
  { label: 'Mauritius - MU', value: 'MU', text: '' },
  { label: 'Mayotte - YT', value: 'YT', text: '' },
  { label: 'Mexico - MX', value: 'MX', text: '' },
  { label: 'Micronesia, Federated States of - FM', value: 'FM', text: '' },
  { label: 'Moldova, Republic of - MD', value: 'MD', text: '' },
  { label: 'Monaco - MC', value: 'MC', text: '' },
  { label: 'Mongolia - MN', value: 'MN', text: '' },
  { label: 'Montenegro - ME', value: 'ME', text: '' },
  { label: 'Montserrat - MS', value: 'MS', text: '' },
  { label: 'Morocco - MA', value: 'MA', text: '' },
  { label: 'Mozambique - MZ', value: 'MZ', text: '' },
  { label: 'Myanmar - MM', value: 'MM', text: '' },
  { label: 'Namibia - NA', value: 'NA', text: '' },
  { label: 'Nauru - NR', value: 'NR', text: '' },
  { label: 'Nepal - NP', value: 'NP', text: '' },
  { label: 'Netherlands - NL', value: 'NL', text: '' },
  { label: 'New Caledonia - NC', value: 'NC', text: '' },
  { label: 'New Zealand - NZ', value: 'NZ', text: '' },
  { label: 'Nicaragua - NI', value: 'NI', text: '' },
  { label: 'Niger - NE', value: 'NE', text: '' },
  { label: 'Nigeria - NG', value: 'NG', text: '' },
  { label: 'Niue - NU', value: 'NU', text: '' },
  { label: 'Norfolk Island - NF', value: 'NF', text: '' },
  { label: 'Northern Mariana Islands - MP', value: 'MP', text: '' },
  { label: 'Norway - NO', value: 'NO', text: '' },
  { label: 'Oman - OM', value: 'OM', text: '' },
  { label: 'Pakistan - PK', value: 'PK', text: '' },
  { label: 'Palau - PW', value: 'PW', text: '' },
  { label: 'Palestinian Authority - PS', value: 'PS', text: '' },
  { label: 'Panama - PA', value: 'PA', text: '' },
  { label: 'Papua New Guinea - PG', value: 'PG', text: '' },
  { label: 'Paraguay - PY', value: 'PY', text: '' },
  { label: 'Peru - PE', value: 'PE', text: '' },
  { label: 'Philippines - PH', value: 'PH', text: '' },
  { label: 'Pitcairn - PN', value: 'PN', text: '' },
  { label: 'Poland - PL', value: 'PL', text: '' },
  { label: 'Portugal - PT', value: 'PT', text: '' },
  { label: 'Puerto Rico - PR', value: 'PR', text: '' },
  { label: 'Qatar - QA', value: 'QA', text: '' },
  { label: 'Reunion - RE', value: 'RE', text: '' },
  { label: 'Romania - RO', value: 'RO', text: '' },
  { label: 'Russian Federation - RU', value: 'RU', text: '' },
  { label: 'Rwanda - RW', value: 'RW', text: '' },
  { label: 'Saint Barthelemy - BL', value: 'BL', text: '' },
  { label: 'Saint Helena, Ascension and Tristan da Cunha - SH', value: 'SH', text: '' },
  { label: 'Saint Kitts and Nevis - KN', value: 'KN', text: '' },
  { label: 'Saint Lucia - LC', value: 'LC', text: '' },
  { label: 'Saint Martin (French part) - MF', value: 'MF', text: '' },
  { label: 'Saint Pierre and Miquelon - PM', value: 'PM', text: '' },
  { label: 'Saint Vincent and the Grenadines - VC', value: 'VC', text: '' },
  { label: 'Samoa - WS', value: 'WS', text: '' },
  { label: 'San Marino - SM', value: 'SM', text: '' },
  { label: 'Sao Tome and Principe - ST', value: 'ST', text: '' },
  { label: 'Saudi Arabia - SA', value: 'SA', text: '' },
  { label: 'Senegal - SN', value: 'SN', text: '' },
  { label: 'Serbia - RS', value: 'RS', text: '' },
  { label: 'Seychelles - SC', value: 'SC', text: '' },
  { label: 'Sierra Leone - SL', value: 'SL', text: '' },
  { label: 'Singapore - SG', value: 'SG', text: '' },
  { label: 'Sint Maarten (Dutch part) - SX', value: 'SX', text: '' },
  { label: 'Slovakia - SK', value: 'SK', text: '' },
  { label: 'Slovenia - SI', value: 'SI', text: '' },
  { label: 'Solomon Islands - SB', value: 'SB', text: '' },
  { label: 'Somalia - SO', value: 'SO', text: '' },
  { label: 'South Africa - ZA', value: 'ZA', text: '' },
  { label: 'South Georgia and the South Sandwich Islands - GS', value: 'GS', text: '' },
  { label: 'South Sudan - SS', value: 'SS', text: '' },
  { label: 'Spain - ES', value: 'ES', text: '' },
  { label: 'Sri Lanka - LK', value: 'LK', text: '' },
  { label: 'Sudan - SD', value: 'SD', text: '' },
  { label: 'Suriname - SR', value: 'SR', text: '' },
  { label: 'Svalbard and Jan Mayen - SJ', value: 'SJ', text: '' },
  { label: 'Swaziland - SZ', value: 'SZ', text: '' },
  { label: 'Sweden - SE', value: 'SE', text: '' },
  { label: 'Switzerland - CH', value: 'CH', text: '' },
  { label: 'Syrian Arab Republic - SY', value: 'SY', text: '' },
  { label: 'Taiwan - TW', value: 'TW', text: '' },
  { label: 'Tajikistan - TJ', value: 'TJ', text: '' },
  { label: 'Tanzania, United Republic of - TZ', value: 'TZ', text: '' },
  { label: 'Thailand - TH', value: 'TH', text: '' },
  { label: 'Timor-Leste - TL', value: 'TL', text: '' },
  { label: 'Togo - TG', value: 'TG', text: '' },
  { label: 'Tokelau - TK', value: 'TK', text: '' },
  { label: 'Tonga - TO', value: 'TO', text: '' },
  { label: 'Trinidad and Tobago - TT', value: 'TT', text: '' },
  { label: 'Tunisia - TN', value: 'TN', text: '' },
  { label: 'Turkey - TR', value: 'TR', text: '' },
  { label: 'Turkmenistan - TM', value: 'TM', text: '' },
  { label: 'Turks and Caicos Islands - TC', value: 'TC', text: '' },
  { label: 'Tuvalu - TV', value: 'TV', text: '' },
  { label: 'Uganda - UG', value: 'UG', text: '' },
  { label: 'Ukraine - UA', value: 'UA', text: '' },
  { label: 'United Arab Emirates - AE', value: 'AE', text: '' },
  { label: 'United Kingdom - GB', value: 'GB', text: '' },
  { label: 'United States - US', value: 'US', text: '' },
  { label: 'United States Minor Outlying Islands - UM', value: 'UM', text: '' },
  { label: 'Uruguay - UY', value: 'UY', text: '' },
  { label: 'Uzbekistan - UZ', value: 'UZ', text: '' },
  { label: 'Vanuatu - VU', value: 'VU', text: '' },
  { label: 'Venezuela, Bolivarian Republic of - VE', value: 'VE', text: '' },
  { label: 'Viet Nam - VN', value: 'VN', text: '' },
  { label: 'Virgin Islands, British - VG', value: 'VG', text: '' },
  { label: 'Virgin Islands, U.S. - VI', value: 'VI', text: '' },
  { label: 'Wallis and Futuna - WF', value: 'WF', text: '' },
  { label: 'Western Sahara - EH', value: 'EH', text: '' },
  { label: 'Yemen - YE', value: 'YE', text: '' },
  { label: 'Zambia - ZM', value: 'ZM', text: '' },
  { label: 'Zimbabwe - ZW', value: 'ZW', text: '' },
]
